export default __webpack_public_path__ + "static/media/putrefaction-crop.546814ed.jpg";